import { render, staticRenderFns } from "./AddressesSettings.vue?vue&type=template&id=aab35f4a&"
import script from "./AddressesSettings.vue?vue&type=script&lang=js&"
export * from "./AddressesSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports